import { Button, Card, Icon, Table, Form } from 'antd'
import _ from 'lodash'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { TableComp } from 'sz-react-utils-lite'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
import { DisplayDate } from '../../../../components/_utils/appUtils'
import { getAllAbstracts } from '../actions'
import ReactHtmlParser from 'react-html-parser';
import { SelectAbstractReviewer } from '../reviewer/SelectAbstractReviewer';
import AbstractActivityList from '../AbstractActivityList'
import ViewMember from '../../../article/articleView/viewMember'
import { SelectReviewer } from '../../../article/reviewer/selectReviewer'
import AbstractFilters from '../abstractPages/AbstractFilters';

@Form.create()
class AllAbstract extends Component {
  state = {
    filters: {},
    ids: {},
    visibleSelectReview: false,
    abstract: {},
    total: '',
    visibleActivityList: false
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      let obj = {
        ...params,
        ...this.state.filters,
        status: 'Abstract Under Review'
      }
      let data = await this.props.dispatch(getAllAbstracts(obj))
      this.setState({ total: data.total })
      resolve(data)
    })
  }

  reload = () => this.table.current.reload()

  events = {
    showDrawer: abstract => {
      let ids = {}
      _.each(abstract.selectedReviewer, value => {
        if (value.reviewerId && value.reviewerId._id) ids[value.reviewerId._id] = true
      })
      this.setState({ ids, visibleSelectReview: true, abstract })
    },
    hideDrawer: () => this.setState({ ids: {}, visibleSelectReview: false, abstract: {} }, () => this.reload())
  }

  reloadTable = data => {
    this.setState({ filters: data }, () => this.reload())
  }

  render() {
    const { visibleSelectReview, ids, abstract, visibleActivityList } = this.state

    const innerTableColumns = [
      {
        title: 'Actions',
        key: 'Actions',
        render: (item, record) => (
          <ViewMember revData={record} revId={record.reviewerId && record.reviewerId._id}>
            <Button className={'roundSmallBtn'}>View Member</Button>
          </ViewMember>
        )
      },
      { title: 'Reviewer', key: 'reviewerId', dataIndex: 'reviewerId', render: item => (item && item.name) ? item.name : '' },
      // { title: 'Remark Date', key: 'commentsDate', dataIndex: 'commentsDate', render: item => item ? DisplayDate(item) : null },
      {
        title: 'Remark Date',
        key: 'commentsDate',
        dataIndex: 'commentsDate',
        render: item => item ? DisplayDate(item) : null
      },
      {
        title: 'Dates',
        key: 'sendDate',
        render: (item) => (
          <div>
            <div>Send Date<br /><label className={'label label-success'}>{DisplayDate(item.assignedDate)}</label></div>
          </div>
        )
      }
    ]

    // const columns = [
    //   {
    //     key: 'actions',
    //     width: 150,
    //     render: (val, record) => (
    //       <React.Fragment>
    //         <a className={'roundSmallBtn'} href={`/abstractView/${record._id}`}>View Details</a>
    //         <Button className={'roundSmallBtn'} onClick={() => this.events.showDrawer(record)}>Add Reviewer</Button>
    //         <Button className={'roundSmallBtn'} onClick={() => this.setState({ visibleActivityList: true, abstract: record })}>
    //           <Icon type="eye" /> Activities
    //         </Button>
    //       </React.Fragment>
    //     )
    //   },
    const columns = [
      {
        key: 'actions',
        width: 150,
        render: (val, record) => (
          <React.Fragment>
            <a className={'roundSmallBtn'} href={`/abstract/view/${record._id}`}>View Details</a>

            {/*<Button className={'roundSmallBtn'} onClick={() => this.events.showDrawer(record)}>Another Reviewer</Button>*/}
            <Button className={'roundSmallBtn'} onClick={() => this.events.showDrawer(record)}>
              Another Reviewer
            </Button>
            <Button className={'roundSmallBtn'} onClick={() => this.setState({ visibleActivityList: true, abstract: record })}>
              Activities
            </Button>
          </React.Fragment>
        )
      },
      {
        title: 'Date',
        key: 'createdAt',
        dataIndex: 'createdAt',
        render: (item) => <label className={'label label-primary'}>{DisplayDate(item)}</label>
      },
      { title: 'Abstract Id', key: 'onlineAbstractId', dataIndex: 'onlineAbstractId' },
      // { title: 'Title', key: 'titleOfAbstract', dataIndex: 'titleOfAbstract' },
      {
        title: 'Title',
        key: 'titleOfAbstract',
        dataIndex: 'titleOfAbstract',
        render: item => {
          return item ? ReactHtmlParser(item) : null;
        }
      },
      { title: 'Author Name', key: 'authorName', dataIndex: 'authorName' },
      {
        title: 'Reviewer Details',
        key: 'selectedReviewer',
        render: (item, record) => (
          <Table columns={innerTableColumns} size={'small'} dataSource={record.selectedReviewer} bordered={true} pagination={false} />
        )
      }
    ]

    return (
      <PageHeaderWrapper title={`Under Review Abstracts (${this.state.total})`}>
        <Card bordered={true}>
          <AbstractFilters
            callback={data => {
              this.reloadTable(data)
            }}
          />
          <TableComp ref={this.table} columns={columns} apiRequest={this.apiRequest} />
        </Card>
        {visibleActivityList && (
          <AbstractActivityList abstractId={abstract._id} visible={visibleActivityList} onClose={() => this.setState({ visibleActivityList: false })} />
        )}
        {visibleSelectReview && (
          <SelectAbstractReviewer
            abstract={abstract}
            ids={ids}
            onClose={this.events.hideDrawer}
            visible={visibleSelectReview}
            page={'abstractView'}
          />
        )}
      </PageHeaderWrapper>
    )
  }
}

const mapStateToProps = ({ global }) => ({ categories: global.categories })
export default connect(mapStateToProps)(AllAbstract)
